var pageHeader = {
    title: "FAQs",
    path: "/faqs"
};
export var faqPage = {
    pageHeader: pageHeader,
};
export default faqPage;
